import {renderField} from "./utils";

export type NestedProps = {
  property: string
  query: string
  score_mode?: string
  ignore_unmapped?: boolean
};

export const nested = (props: NestedProps): string => {
  return `
    {
      nested: {
        ${props.property}: {
          query: ${props.query}
          ${renderField('score_mode', props.score_mode)}
          ${renderField('ignore_unmapped', props.ignore_unmapped)}
        }
      }
    }
  `;
};
